import React from 'react';
import { GeneralErrorPage, GeneralErrorPageProps } from '../GeneralErrorsPage/GeneralErrorsPage';

const withAccountDeletedText = (WrappedComponent: React.FC<GeneralErrorPageProps>) => {
    return (props: GeneralErrorPageProps) => {
        const {
            titleKey = 'SETTINGS.NOT_AUTHORIZED.MESSAGE_TITLE',
            firstMessageKey = 'SETTINGS.NOT_AUTHORIZED.MESSAGE_FIRST',
            secondMessageKey = 'SETTINGS.NOT_AUTHORIZED.MESSAGE_SECOND',
        } = props;

        return (
            <WrappedComponent
                titleKey={titleKey}
                firstMessageKey={firstMessageKey}
                secondMessageKey={secondMessageKey}
            />
        );
    };
};

const NotAuthorizedPage = withAccountDeletedText(GeneralErrorPage);

export default NotAuthorizedPage;
